import { motion } from "framer-motion";
import { useAppSelector } from "../../../app/hooks";
import { selectCurrentBuilder } from "../../../app/features/builder/builderSlice";
import { NoteViewer } from "./NoteViewer";
import { NoteEditor } from "./NoteEditor";
import { useNotes } from "./hooks/useNotes";
import { AddNoteButton } from "./AddNoteButton";
import TranslatableText from "../../translations/TranslatableText";
import ConfirmationModal from "../../modal/ConfirmationModal";

const NotesAction = () => {
	const { tabsOpen } = useAppSelector(selectCurrentBuilder);
	const {
		notes,
		editMode,
		isLoading,
		error,
		canMutateNote,
		isFinalized,
		pendingDeleteId,
		handleSaveNotes,
		setEditMode,
		confirmDelete,
		cancelDelete,
		handleDeleteNote
	} = useNotes();

	const renderNoteContent = () => {
		if (isLoading) {
			return <div><p>Loading Data...</p></div>;
		}

		return (
			<div className="selected-note-block">

				{!notes && canMutateNote && !isFinalized && (
					<AddNoteButton onAdd={() => setEditMode(true)} />
				)}

				{!notes && !canMutateNote && (
					<TranslatableText
						className="fs-12 text-darker-gray"
						translationKey="module.not_allowed_add_notes"
					/>
				)}

				{!editMode && notes && (
					<NoteViewer
						notes={notes}
						canMutateNote={canMutateNote}
						onEdit={() => setEditMode(true)}
						onDelete={() => confirmDelete(notes.id)}
					/>
				)}

				{editMode && (
					<NoteEditor
						notes={notes}
						onSave={handleSaveNotes}
						onCancel={() => setEditMode(false)}
						isLoading={isLoading}
					/>
				)}

				{error && (
					<div className="pt-2">
						<span className="text-error">{error}</span>
					</div>
				)}

				<ConfirmationModal
					open={pendingDeleteId !== null}
					onCancel={cancelDelete}
					onConfirm={handleDeleteNote}
					message={<TranslatableText translationKey="module.delete_note_confirmation" />}
					headerText="module.delete_note_header"
					size="sm"
				/>
			</div>
		);
	};

	return (
		<motion.section
			className="notes-action-container"
			initial={{ width: 0 }}
			animate={{ width: tabsOpen ? "inherit" : 0 }}
			exit={{ width: 0 }}
		>
			{renderNoteContent()}
		</motion.section>
	);
};

export default NotesAction;
